import styled from 'styled-components';
import { Grid, Dialog } from '@material-ui/core';

// COMPONENTS
import ChannelCard from '@/components/Cards/ChannelCard';

// CONSTANTS
import colors from '@/constants/colors';
import { breakpoints } from '@/utility/breakpoints';

// COMPONENTS
import Loader from '@/components/Loader';

// STYLES
import { Container as ContainerS } from '../../styles';

export const Container = styled(ContainerS)`
  position: static;
  min-height: 350px;

  ${breakpoints.down('xs')} {
    min-height: 225px;
  }
`;

export const DialogStyled = styled(Dialog)`
  .dialog,
  &.dialog {
    &__close-button {
      position: absolute;
      top: 6px;
      right: 6px;
      font-size: 30px;
      color: ${p => p.theme.palette.text.secondary};
    }

    &__title {
      max-width: 540px;
      margin: 0 auto;
      padding-top: 56px;
    }

    &__content {
      padding-bottom: 32px;
    }

    &__actions {
      padding: 16px;
    }

    &__button {
      width: 151px;
    }
  }
`;

export const LoaderStyled = styled(Loader)``;

export const FilterWrapper = styled.div`
  .filter {
    &__search {
      .MuiAutocomplete-inputRoot {
        padding: 11px 9px;
      }
    }

    &__count {
      margin-right: 15px;
      white-space: nowrap;
      font-size: 1.6rem;
      line-height: 1.6rem;
    }

    &__zipcode {
      .zipcode__input {
        background-color: transparent;
      }
    }
  }
`;

export const Content = styled.div`
  padding: 40px 0 0;
`;

export const SmallerChannelCard = styled(ChannelCard)`
  &.channels_on_app {
    background: ${colors.error} !important;
  }
`;

export const ChannelsGrid = styled(Grid)`
  .MuiGrid-item {
    display: flex;
  }

  .channel-card {
    display: flex;
    width: 100%;

    &--hover {
      &:hover {
        box-shadow: 0px 20px 40px 0px #00000014;
        cursor: default;
      }
    }

    .channel-card__container {
      padding: 10px;
      min-height: auto;
      img {
        max-width: 100%;

        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
          width: 100%;
        }
      }
    }
  }
`;

export default Content;
